import { getSourceFilePathObj } from "~/utils/miscellaneous";
import cloneDeep from "lodash/cloneDeep";
import pick from "lodash/pick";
import isEqual from "lodash/isEqual";

const sharedLibGqlContext = require.context("~/assets/gql", true, /.*\.js$/);

export default class GraphQL {
  constructor(axios, gqlContext, appGlobals) {
    this.__axios = axios;
    this.__gqlContext = gqlContext;
    this.__appGlobals = appGlobals;
    this.cacheData = [];
  }
  getFromCache(requestArgsParam) {
    return this.cacheData.find(({ requestArgs }) =>
      isEqual(requestArgs, requestArgsParam)
    );
  }
  callGql(config, { isMock, cache } = {}) {
    const graphqlUrl = this.__appGlobals.envSelector[
      isMock ? "mockVueEnvConfig" : "selectedVueEnvConfig"
    ].value.services.graphql.url;

    if (typeof config == "string") {
      config = {
        gql: config,
      };
    }

    const sourceFilePathObj = getSourceFilePathObj(config.gql);

    Object.assign(config, {
      gqlSource: sourceFilePathObj.source,
      gqlFilePath: sourceFilePathObj.filePath,
    });

    const gqlRequireFilePath = `./${config.gqlFilePath}.js`;

    let gql;

    try {
      gql =
        config.gqlSource == "shared-lib"
          ? sharedLibGqlContext(gqlRequireFilePath)
          : this.__gqlContext(gqlRequireFilePath);
    } catch (error) {
      const errorMessage =
        error.code == "MODULE_NOT_FOUND"
          ? `${gqlRequireFilePath} file not found`
          : error.message;
      console.error("callGql error:", errorMessage);
      throw Error(errorMessage);
    }

    gql = cloneDeep(gql.default || gql);

    config.meta = gql.meta;

    if (config.variables) gql.variables = config.variables;

    //dont use cloneDeep here, as we can pass instances in config
    let axiosConfig = Object.assign({}, config);

    delete axiosConfig.gql;
    delete axiosConfig.variables;

    const payload = pick(gql, ["query", "variables"]);
    const isCurMock = this.__axios._isMockEnabled || isMock;

    const requestArgs = [
      isCurMock
        ? `${config.gqlSource == "shared-lib" ? "shared-lib:" : ""}${graphqlUrl}${config.gqlFilePath}`
        : graphqlUrl,
      payload,
      axiosConfig,
    ];

    const curCacheData = cache ? this.getFromCache(requestArgs) : null;

    return Promise.resolve(
      (cache && curCacheData?.response) ||
        this.__axios[isCurMock ? "getMock" : "post"](...requestArgs)
    ).then((response) => {
      if (cache && !curCacheData)
        this.cacheData.push({
          requestArgs,
          response,
        });
      return response;
    });
  }
}
